export const common = {
  nav: {
    services: 'Servicios',
    about: 'Nosotros',
    whyUs: 'Por Qué Elegirnos',
    portfolio: 'Portafolio',
    contact: 'Contacto'
  },
  hero: {
    headline: 'Soluciones Digitales Inteligentes para Elevar tu Negocio',
    subheadline: 'Conectamos ideas y tecnología para hacer crecer tu negocio',
    ctaPrimary: 'Agenda una Consulta Gratis',
    ctaSecondary: 'Ver Servicios'
  },
  services: {
    title: 'Lo Que Ofrecemos',
    subtitle: 'Soluciones digitales integrales adaptadas a las necesidades de tu negocio',
    websites: {
      title: 'Sitios Web',
      description: 'Sitios web responsivos, modernos y enfocados en conversión que generan resultados'
    },
    branding: {
      title: 'Branding e Identidad Visual',
      description: 'Diseño de logos, kits de marca y consistencia visual para tu negocio'
    },
    printing: {
      title: 'Impresión',
      description: 'Tarjetas de presentación, volantes, banners y materiales de marketing'
    },
    itSupport: {
      title: 'Soporte IT y Digital',
      description: 'Soporte técnico, configuración, mantenimiento y ayuda continua'
    }
  },
  websites: {
    title: 'Diseño Web que Convierte',
    subtitle: 'Diseñamos sitios web rápidos, responsivos y visualmente atractivos, enfocados en la experiencia del usuario y el crecimiento del negocio.',
    portfolio: {
      title: 'Nuestros Proyectos Web',
      subtitle: 'Sitios web reales que hemos construido para negocios reales',
      livePreview: 'Ver Sitio',
      responsive: 'Totalmente adaptable a todos los dispositivos',
      comingSoon: 'Más Proyectos Próximamente'
    },
    projects: {
      miunaesperanzaviva: {
        name: 'Mi Una Esperanza Viva',
        description: 'Sitio web institucional con diseño limpio y contenido estructurado.'
      },
      suadicor: {
        name: 'Suadicor',
        description: 'Sitio web de servicios enfocado en claridad y generación de clientes.'
      }
    },
    cta: {
      title: '¿Quieres un sitio web como este? Hagamos el tuyo.',
      quote: 'Solicitar Cotización',
      whatsapp: 'Escríbenos por WhatsApp'
    }
  },
  about: {
    title: 'Acerca de BridgeOn Solutions',
    description: 'Somos una agencia creativa digital dedicada a ayudar a pequeñas y medianas empresas en EE.UU. a prosperar en el mundo digital. Con un enfoque en calidad, innovación y confiabilidad, cerramos la brecha entre tu visión y la tecnología de vanguardia. Nuestra misión es entregar soluciones personalizadas que no solo cumplan tus necesidades, sino que superen tus expectativas, impulsando un crecimiento empresarial real.'
  },
  whyUs: {
    title: 'Por Qué Elegirnos',
    subtitle: 'Lo que nos hace diferentes',
    custom: {
      title: 'Soluciones Personalizadas',
      description: 'Estrategias a medida diseñadas específicamente para tus objetivos empresariales'
    },
    support: {
      title: 'Soporte Confiable',
      description: 'Asistencia 24/7 para mantener tu negocio funcionando sin problemas'
    },
    technology: {
      title: 'Tecnología Moderna',
      description: 'Herramientas y plataformas de vanguardia para un rendimiento óptimo'
    },
    results: {
      title: 'Resultados Enfocados en el Negocio',
      description: 'Enfoque basado en datos que entrega crecimiento medible'
    }
  },
  contact: {
    title: 'Trabajemos Juntos',
    subtitle: '¿Listo para elevar tu negocio? Contáctanos hoy',
    form: {
      name: 'Nombre y Apellido',
      email: 'Correo',
      phone: 'Teléfono',
      company: 'Empresa (opcional)',
      service: 'Servicio que Necesitas',
      message: 'Mensaje',
      submit: 'Enviar Mensaje',
      selectService: 'Selecciona un servicio',
      services: {
        websites: 'Sitios Web',
        branding: 'Branding',
        printing: 'Impresión',
        itSupport: 'Soporte IT y Digital'
      }
    },
    info: {
      email: 'Correo',
      phone: 'Teléfono',
      website: 'Sitio Web'
    },
    whatsapp: 'Escríbenos por WhatsApp'
  },
  footer: {
    tagline: 'Conectando ideas y tecnología',
    quickLinks: 'Enlaces Rápidos',
    followUs: 'Síguenos',
    copyright: '© 2025 BridgeOn Solutions. Todos los derechos reservados.',
    poweredBy: 'Website Builder'
  }
};